<template>
  <div class="stat-courier-page">
    <v-container fluid>
      <stat-top-filter
        :filial-default="globalFilialId"
        hide-days-diff
        @applyFilter="fetchData"
      >
        <template #date-picker>
          <period-date-picker
            :period-type.sync="periodType"
            @selected="selectDate"
          />
        </template>
        <template #additional-filter>
          <v-checkbox
            v-model="withoutAggregators"
            label="Отображать без агрегаторов"
            max-width="480px"
            flat
            solo
          />
        </template>
      </stat-top-filter>

      <dynamics-indicators-list
        v-if="Object.keys(indicators).length"
        class="mb-5"
        :without-aggregators="withoutAggregators"
        :indicators="indicators"
        :loading="isLoading"
      />

      <chart-container
        class="mb-5"
        :loading="isLoading"
        :no-data="!revenueDynamics.length"
      >
        <template #chart>
          <dynamics-chart
            v-if="revenueDynamics.length"
            :items="revenueDynamics"
            :period-type="chartPeriodType"
            legend-container-id="dynamics"
          />
        </template>
      </chart-container>

      <v-row>
        <v-col md="6" cols="12">
          <chart-container
            style="height: 100%"
            :loading="isLoading"
            :no-data="proportionByClientsEmpty"
          >
            <template #chart>
              <proportion-chart
                title="Клиенты - Новые и постоянные"
                :items="proportionByClients"
                :colors="['#4DAF4A', '#EB5388']"
                legend-container-id="proportion-by-clients"
              />
            </template>
          </chart-container>
        </v-col>
        <v-col md="6" cols="12">
          <chart-container
            style="height: 100%"
            :loading="isLoading"
            :no-data="proportionByDeliveryEmpty"
          >
            <template #chart>
              <proportion-chart
                title="Доставка и самовывоз"
                :items="proportionByDelivery"
                :colors="['#4DAF4A', '#FF9D00']"
                legend-container-id="proportion-by-delivery"
              />
            </template>
          </chart-container>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
  import StatTopFilter from '@/components/stat/StatTopFilter.vue'
  import PeriodDatePicker from '@/components/ui/PeriodDatePicker.vue'
  import { mapGetters } from 'vuex'
  import revenueDynamicsApi from '@/api/statistics/revenue/dynamics'
  import revenueProportionApi from '@/api/statistics/revenue/proportion'
  import PeriodType from '@/models/enums/statistics/PeriodType'
  import DynamicsChart from '@/components/stat/revenue/DynamicsChart.vue'
  import DynamicsIndicatorsList from '@/components/stat/revenue/DynamicsIndicatorsList.vue'
  import ProportionChart from '@/components/stat/revenue/ProportionChart.vue'
  import ChartContainer from '@/components/stat/ChartContainer.vue'

  export default {
    name: 'RevenueDynamics',
    components: {
      ChartContainer,
      StatTopFilter,
      DynamicsChart,
      PeriodDatePicker,
      DynamicsIndicatorsList,
      ProportionChart,
    },
    data () {
      return {
        showDaysCount: 30,
        isLoading: false,
        indicators: {},
        revenueDynamics: [],
        date: [],
        proportionByClients: [],
        proportionByDelivery: [],
        periodType: PeriodType.Week,
        chartPeriodType: PeriodType.Week,
        withoutAggregators: false,
      }
    },
    computed: {
      ...mapGetters({
        globalFilialId: 'branches/getGlobalFilialId',
      }),
      proportionByClientsEmpty () {
        return this.proportionByClients.every((item) => !item.percent)
      },
      proportionByDeliveryEmpty () {
        return this.proportionByDelivery.every((item) => !item.percent)
      },
    },
    methods: {
      selectDate (date) {
        this.date = date
      },
      fetchData (filter) {
        this.$nextTick(() => {
          this.chartPeriodType = this.periodType

          const data = {
            filialPreset: filter.filialPreset,
            periodType: this.periodType,
            withoutAggregators: this.withoutAggregators,
          }

          if (filter.filialId) {
            data.filialIds = Array.isArray(filter.filialId)
              ? filter.filialId
              : [filter.filialId]
          }

          switch (this.periodType) {
            case PeriodType.Week:
              data.dateRange = this.date
              break
            case PeriodType.Month:
              data.month = this.date
              break
            case PeriodType.Year:
              data.year = this.date
          }

          this.isLoading = true

          Promise.all([
            revenueDynamicsApi.fetchRevenueDynamicsIndicators(data),
            revenueDynamicsApi.fetchRevenueDynamics(data),
            revenueProportionApi.fetchRevenueProportionByClients(data),
            revenueProportionApi.fetchRevenueProportionByDelivery(data),
          ])
            .then((responses) => {
              this.indicators = responses[0].data
              this.revenueDynamics = responses[1].items
              this.proportionByClients = this.prepareProportionData(
                responses[2].items,
              )
              this.proportionByDelivery = this.prepareProportionData(
                responses[3].items,
              )
            })
            .catch((err) => this.showErrorFromResponse(err))
            .finally(() => {
              this.isLoading = false
            })
        })
      },
      prepareProportionData (items) {
        return items.map((item) => {
          if (item.value) {
            item.formattedValue = this.$options.filters.amountWithCurrency0(
              item.value,
            )
          }

          return item
        })
      },
    },
  }
</script>

<style lang="less" scoped>
@import '@/assets/styles/statistic.less';

::v-deep {
  .v-input--checkbox {
    .v-input--selection-controls__input {
      .v-icon:before {
        color: @color-primary;
      }
    }

    .v-label {
      line-height: 1.1;
      color: #949191;
    }
  }
}
</style>
